// Who the ?live=1 site opens on (Ben, 2026-10-16). The snapshot site keeps the original demo
// (McCabe, van Domselaar); with real data Ben wanted a player with data in every module:
// Declan Rice, and David Raya for the Goalkeeping tile (both Arsenal, Premier League).
//
// Neither is in the snapshot, so on boot they're remembered as live picks (the pickers can
// then offer them and show their names) and as men (so a Stats / Radar tile accepts them as
// drops straight away). Plain code, no Amplify: the canvas imports it.

import type { PlayerId } from "../data/players.js";
import { getStickyPlayer, setStickyPlayer } from "../canvas/sticky-player.js";
import { rememberPickedPlayer, type PickedPlayer } from "./picked-players.js";
import { rememberWomens } from "./player-gender.js";

export const LIVE_DEFAULT_PLAYER: PickedPlayer = { id: 3943, name: "Declan Rice", team: "Arsenal" };
// The DB's name is "David Raya Martin", which the pickers would shorten to "David Martin".
export const LIVE_DEFAULT_GOALKEEPER: PickedPlayer = { id: 4127, name: "David Raya", team: "Arsenal" };

/** Run once at live boot: remember both, and make Rice the player new modules open on
 *  (the "All" button and hand-dragged tiles alike) until the user picks someone else. */
export function seedLiveDefaults(): void {
  for (const p of [LIVE_DEFAULT_PLAYER, LIVE_DEFAULT_GOALKEEPER]) {
    rememberPickedPlayer(p);
    rememberWomens(p.id, false);
  }
  if (getStickyPlayer() === null) setStickyPlayer(LIVE_DEFAULT_PLAYER.id);
}

/**
 * A new Goalkeeping tile with no player of its own: on the live site, while the canvas is
 * still on the default player, it opens on the default goalkeeper instead (Rice has no
 * keeper numbers). Anyone else picked → unchanged.
 */
export function liveGoalkeeperFor(sticky: PlayerId | null): PlayerId | null {
  return sticky === LIVE_DEFAULT_PLAYER.id ? LIVE_DEFAULT_GOALKEEPER.id : null;
}
